import React from 'react';
import {  Show,BooleanField,
BooleanInput,ShowButton,List,EditButton,SimpleForm,
 Datagrid,RichTextInput,DisabledInput,TextInput,Edit,
TextField, RichTextField ,SimpleShowLayout,TabbedForm,FormTab,Create
 }
from 'admin-on-rest/lib/mui';

export const ProviderNumberList = (props) => (
    <List title="מספרי ספק" {...props}>
        <Datagrid>
            <TextField label="#" source="id" />
              <TextField label="מספר ספק" source="provider_number" />
              <BooleanField label="פעיל" source="active" />
   <EditButton />
            <ShowButton />
        </Datagrid>
    </List>
);

const ProviderNumberTitle = ({ record }) => {
    return <span>ProviderNumber {record ? `"${record.ProviderNumber}"` : ''}</span>;
};


export const ProviderNumberShow = (props) => (

<Show title={<ProviderNumberTitle />} {...props}>
 <SimpleShowLayout>
        <TextField label="#" source="id" />
        <TextField label="מספר ספק" source="provider_number" />
        <BooleanField label="פעיל" source="active" />

         </SimpleShowLayout>
    </Show>
);


export const ProviderNumberEdit = (props) => (
    <Edit {...props}>

        <SimpleForm>
 <DisabledInput source="id" />
<TextInput  label="מספר ספק" source="provider_number" />
<BooleanInput label="פעיל" source="active" />
        </SimpleForm>
  </Edit>
);

export const ProviderNumberCreate = (props) => (
    <Create title="הוספת סוג מספר ספק חדש" {...props}>
      <SimpleForm >

              <DisabledInput label="Id" source="id" />
                <TextInput source="provider_number" label="מספר ספק"/>

<BooleanInput label="פעיל" source="active" />




      </SimpleForm>
    </Create>
);



// WEBPACK FOOTER //
// ./src/components/ProviderNumber/providernumber.js